import { Box, BoxProps } from "@mui/material";

const Chip = ({ sx, ...rest }: BoxProps) => (
  <Box
    sx={{
      border: "1px solid #d5d5d8",
      borderRadius: "4px",
      backgroundColor: "#fff",
      fontSize: 12,
      color: "grey.900",
      px: "6px",
      py: "4px",
      userSelect: "none",
      ...(sx || {}),
    }}
    {...rest}
  />
);

export default Chip;
